export { default } from './TextSearch'
